// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $('body'),
    _productObj: {}
  }
};

timber.init = function () {
  // FastClick.attach(document.body);
  timber.cacheSelectors();
};

timber.productPage = function (options) {
  // console.log(options);
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector,
      translations = options.translations,
      product = options.selector.product;
      // console.log(translations)
      // console.log(variant.inventory_quantity)
  var item_id = "#" + selector.domIdPrefix;
  var $productImage = $(item_id).closest('form').find('.product-single__photos').find('img'),
      $addToCart = $(item_id).closest('form').find('.AddToCart:visible').not('.noClick'),
      $productPrice = $(item_id).closest('form').find('.product-single__price'),
      $productComparePrice = $(item_id).closest('form').find('.product-compare__price'),
      
      $addToCartText = $addToCart.find('.AddToCartText');
  // console.log(variant,product);
  // Update variant image, if one is set
  var newImg = variant && variant.featured_image ? variant.featured_image.src : product.featured_image,
      newImgId = variant && variant.featured_image ? variant.featured_image.id : '',
      el = $productImage[0];
    timber.switchImage(newImg,{ id: newImgId }, el);

  if (variant) {
    // Select a valid variant if available
    if (variant.available) {
      if($addToCartText.data("type") && $addToCartText.data("type") == 'pre_order'){
        $addToCartText.html(translations.pre_order_now);
        $addToCartText.attr('text', translations.pre_order_now);
      }else{
        $addToCartText.html(translations.add_to_cart);
        $addToCartText.attr('text', translations.add_to_cart);
      }
      $addToCart.removeClass('disabled').prop('disabled', false);
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      // console.log(translations.sold_out)
      // console.log($addToCartText);
      $addToCartText.html(translations.sold_out);
      $addToCartText.attr('text', translations.sold_out);
      $addToCart.addClass('disabled').prop('disabled', true);
    }

    // Regardless of stock, update the product price
    var variantPrice = Shopify.formatMoney(variant.price, moneyFormat);
    $productPrice.html(variantPrice);
    $productPrice.attr('content', (variant.price / 100).toFixed(2));

    console.log("grid-product-form.js.liquid")
    console.log(variant)
    if (variant.compare_at_price > variant.price) {
      var variantComparePrice = Shopify.formatMoney(variant.compare_at_price, moneyFormat);
      if ($productComparePrice) {
        $productComparePrice.show().html(variantComparePrice);
        $productComparePrice.attr('content', (variant.compare_at_price / 100).toFixed(2));
      }else{
        var compare_price_html = `<div class="flex space-x-1 line-through font-light text-grey ml-2.5">
          <span class="block">USD</span>
          <span class="product-compare__price" itemprop="price" content="${(variant.compare_at_price / 100).toFixed(2)}">
          ${variantComparePrice}
        </span></div>`;
        $productPrice.closest('.form-single__prices').append(compare_price_html)
      }
    }else{
      $productComparePrice && $productComparePrice.hide();
    }
  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html(translations.unavailable);
    $addToCartText.attr('text', translations.unavailable);
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  // console.log(el)
  var $el = $(el);
  $el.attr('src', src);
  $el.attr('data-src', src);
  $el.attr('data-image-id', imgObject.id);
};

timber.selectVariant = function(index, productObj){
  new Shopify.OptionSelectors(`productSelect_${index}`, {
    product: productObj,
    onVariantSelected: selectCallback,
    enableHistoryState: false
  });
}

timber.changeOption = function (product_handle,selectValue,selectIndex){
  const productOptions = timber.cache._productObj.options;
  // console.log(product)
  const singleOption_index = 0;
  var length = 1;
  for (let i = 0; i < productOptions.length; i++) {
    const singleOptionSelector = `#productSelect_${selectIndex}-option-${i}`;
    const singleOptionLength = document.querySelector(singleOptionSelector).children.length;
    length *= singleOptionLength;
  }

  const options = document.querySelector(`#productSelect_${selectIndex}`).children;
  const optionLength = options.length - 1;
  if (length == optionLength) {
    return;
  }

  const swatchSelectClass = productOptions[1].name.toLowerCase();
  const productSelectId = `#productSelect_${selectIndex}-option-${singleOption_index}`;

  const singleOptions =  document.querySelector(productSelectId).children;
  var optionArr = [];
  for (let j = 0; j < singleOptions.length; j++) {
    const singleOptionValue = singleOptions[j].innerText;
    var optionData = {};
    //console.log(singleOptionValue)
    var singleArr = [];
    for (let i = 0; i < optionLength; i++) {
      const optionValue = options[i].innerText.trim().split(" - $")[0];
      //console.log(optionValue,singleOptionValue);
      const optionValueArr = optionValue.split(" / ");
      if (optionValueArr[singleOption_index] == singleOptionValue) {
        singleArr.push(optionValueArr[1]);
      }
    }
    var singleUniqueArr = singleArr.filter(function(item,index){
      return singleArr.indexOf(item) == index;
    })

    // console.log(singleArr)
    if (singleUniqueArr.length > 0) {
      optionData.option = swatchSelectClass;
      optionData.name = singleOptionValue;
      optionData.arr = singleUniqueArr;

      optionArr.push(optionData); 
    }
  }
  // console.log(optionArr)
  for (let index = 0; index < optionArr.length; index++) {
    const name = optionArr[index].name;
    // console.log(name,selectValue);
    if (name == selectValue) {
      const valueList = optionArr[index].arr;
      const swatchClass = optionArr[index].option;
      const valueList_type = valueList.map(item => item.includes(' | ') ? item.split(' | ')[1] : item);
      $('.grid-form-modal .option-types').length > 0 && $('.grid-form-modal .option-types').find('.option-type').each(function(){
        const $this_type = $(this);
        const typeValue = $this_type.data('type');
        if(valueList_type.includes(typeValue)){
          $this_type.removeClass("disable").prop("disabled", false);
        }else{
          $this_type.addClass("disable").prop("disabled", true);
        }
      });
      $(`.grid-form-modal .swatch-element.${swatchClass}`).each(function(){
        const $this_swatch = $(this);
        const swatchValue = $this_swatch.data('value');

        if (valueList.includes(swatchValue)) {
          $this_swatch.find("input[type='radio']").prop("disabled", false);
          $this_swatch.removeClass("disable");
        }else{
          $this_swatch.find("input[type='radio']").prop("disabled", true);
          $this_swatch.addClass("disable");
        }
      });
      const radioValue = $(`#productSelect_${selectIndex}-option-1`).val();
      const checkReturn = valueList.length === 1 ? valueList.includes(radioValue) : (valueList.includes(radioValue) || radioValue == "");
      if (checkReturn) {
        return;
      }
      // console.log(swatchClass)
      $(`.grid-form-modal .swatch-element.${swatchClass}`).not('.disable').eq(0).find("input[type='radio']").click();
    }
  }
}

timber.renderFormModal = function (product_handle,form_index,selected_variant) {
  // 移除所有现有的模态框,防止重复
  $('body>.grid-form-modal').remove();
  $('.grid-form-modal').remove();

  $.getJSON(`/products/${product_handle}.js`, function (product) {
    // console.log(product)
    timber.cache._productObj = product;
    if(!product.available){
      return false;
    }
    const product_variants = product.variants;
    const form_variant = product_variants.filter(item => item.available)[0];
    const form_id = `form_${form_variant.id}`;
    const variant_image = form_variant.featured_image;
    const variant_image_180 = variant_image ? variant_image.src.split('.webp')[0] + '_180x180.webp' + variant_image.src.split('.webp')[1] : product.featured_image;
    const variant_image_id = variant_image ? variant_image.id : form_variant.id;
    const soldout_src = `https://www.ipitaka.com/cdn/shop/t/84/assets/soldout.webp?v=2024`;

    const formTitleClass = 'text-size-14 sm:text-size-16 md:text-size-18 lg:text-size-20 xl:text-size-24';
    var title_variant_html = '';
    if(product_handle.includes('-phone-cases')){
      title_variant_html = `<span class="variant-title font-light text-grey flex flex-wrap"></span>`;
    }
    const form_title = `<h4 class="${formTitleClass} flex-shrink-0">${title_variant_html}<span class="block leading-tight">${product.title}</span></h4>`;
    const variant_price = Shopify.formatMoney(form_variant.price, "");
    var form_prices = `<div class="flex space-x-1"><span class="block">USD</span><span class="product-single__price" itemprop="price">
        ${variant_price}
      </span></div>`;
    if(form_variant.compare_at_price > form_variant.price){
      const variant_compare_price = Shopify.formatMoney(form_variant.compare_at_price, "");
      form_prices += `<div class="flex space-x-1 line-through font-light text-grey ml-2.5"><span class="block">USD</span><span class="product-compare__price">
        ${variant_compare_price}
      </span></div>`;
    }
    const quantifyMax = form_variant.inventory_policy == 'deny' ? form_variant.inventory_quantity : 999;
    var form_options = '';
    for (let i = 0; i < product_variants.length; i++) {
      const variant_item = product_variants[i];
      const variant_quantifyMax = variant_item.inventory_policy == 'deny' ? variant_item.inventory_quantity : 999;
      const variant_item_price = Shopify.formatMoney(variant_item.price, "");
      const form_option = `<option value="${variant_item.id}" data-quantity="${variant_quantifyMax}">
        ${variant_item.title} - ${variant_item_price}
      </option>`;
      form_options += form_option;
    }
    form_options += `<option value="${form_variant.id}" data-quantity="${quantifyMax}">
        ${form_variant.title} - ${variant_price}
      </option>`;
    var form_swatches = '', form_button;
    const handlezie_value = value => value != '' && value.replaceAll(/[\/\`\~\!\@\#\$\%\^\&\*\(\)\_\+\-\=\{\}\|\[\]\:\;\'\<\>\?\,\.]+/g,' ').replace(/\s+/g,' ').trim().replaceAll('™','').replaceAll(' ','-').toLowerCase();
    
    var product_name = product_handle, remove_strs;
    if (product_handle.includes('-case-')) {
      if (product_handle.includes('chinese-new-year')){
        product_name = 'chinese-dragon-case5';
      }else if (product_handle.includes('sunset-moonrise-case')){
        product_name = 'sunset-moonrise-case';
      }else if (product_handle.includes('three-body')){
        product_name = 'three-body';
      }else{
        remove_strs = ['pitaka-','case-','for-','samsung-galaxy-','google-','huawei-','-series','-iphone-14-and-galaxy-s23','phone-'];
        // product_name = remove_strs.forEach(item => {product_handle.replace(item,'')});
        product_name = product_name.replace('pro-2020-and-2018', '2020');
        for (let i = 0; i < remove_strs.length; i++) {
          const str = remove_strs[i];
          product_name = product_name.replace(str,'');
        }
      }
    }else if (product_handle == 'carbon-fiber-watch-band-rhapsody-version-for-apple-watch') {
      product_name = 'iwatch-band';
    }else if (product_handle.includes('dreamland-chromacarbon-band')) {
      product_name = 'dreamland-chromacarbon-iwatch-band';
    }else if (product_handle.includes('poetry-of-things-chromacarbon-band')) {
      product_name = 'poetry-chromacarbon-band';
    }else if (product_handle == 'screen-protector-for-samsung-galaxy-s24') {
      product_name = 'screen-protector-galaxy-s24';
    }else {
      remove_strs = ['pitaka-','-for-s24','-for-airtag','magez-','air-','for-','-iphone-14-and-galaxy-s23'];
      remove_strs.forEach(item => {
        if(product_name.includes(item)){
          product_name = product_name.replace(item,'');
        }
      });
    }
    if(product.available && product_variants.length > 1){
      for (let i = 0; i < product.options.length; i++) {
        const option = product.options[i].name;
        const downcased_option = handlezie_value(option);
        var is_color = false, is_device = false, color_index = 0;

        if(downcased_option.includes('color') || downcased_option.includes('colour') || downcased_option == 'carbon-fiber-watch-band'){
          is_color = true;
          color_index = i;
        }
        if(downcased_option == 'device'){
          is_device = true;
        }
        var swatch_title = is_color || is_device ? `${option} <span class="option_context_${downcased_option} ml-2 text-grey"></span>` : option;
        if (is_color && product_handle.includes('-phone-cases')) {
          const selected_variant_color = selected_variant.split(' / ')[1];
          var pitatap_info_show = 'hidden', aaron_info_show = 'hidden';
          if (selected_variant_color.includes('PitaTap')) {
            pitatap_info_show = 'block';
          }else if (selected_variant_color.includes('Aaron Button')) {
            aaron_info_show = 'block';
          }
          swatch_title += `<a href="javascript:;"
            class="${pitatap_info_show} pitatap_info_trigger mt-1.5 sm:mt-2.5 md:mt-0 absolute top-20 md:top-0 md:right-0 font-light text-grey border-b" >
            Know more about PitaTap™ >>
          </a><a href="javascript:;"
            class="${aaron_info_show} aaron_info_trigger mt-1.5 sm:mt-2.5 md:mt-0 absolute top-20 md:top-0 md:right-0 font-light text-grey border-b" >
            Know more about Aaron Button >>
          </a>`;
        }
        var swatch_variants = '', roundedClass, variant_values = [];
        for (let j = 0; j < product_variants.length; j++) {
          var variant_value = product_variants[j].options[i].trim();
          if(!variant_values.includes(variant_value)){
            variant_values.push(variant_value);
            if(is_color){
              roundedClass = 'color mr-1.5 mb-1 sm:mr-2 sm:mb-1.5 xl:mr-3';
            }else{
              roundedClass = `${downcased_option} mr-1.5 mb-1.5 sm:mr-2 xl:mb-2`;
            }
            if(product_handle.includes('samsung-galaxy-')){
              variant_value = variant_value.replace('+','p');
            }

            const handle_value = handlezie_value(variant_value);
            var swatch_label;
            if(is_color){
              var color_src;
              const handle_value_color = handlezie_value(variant_value.includes(' | ') ? variant_value.split(' | ')[0].includes('10th Anniversary') ? variant_value.split(' | ')[0].replace(' (PitaTap™)','').replace('(10th Anniversary Edition)','10th') : variant_value.split(' | ')[0] : variant_value);
              var color_prefix = product_handle.includes('pixel-game') ? 'weaving-pixel-game' : handle_value_color.replace('1500d-','');
              const is_webp = product_handle.includes('happiness-rides-in') || product_handle.includes('gift-wrapping') || product_handle.includes('threads-of-winter') || variant_value.includes('Lucid Blue') || variant_value.includes('Golden Glint') || product_handle.includes('re-tros') || variant_value.includes('Marble') || variant_value.includes('PitaTap') || variant_value.includes('Aaron Button') || variant_value.includes('10th') || variant_value.includes('Forest') || variant_value.includes('Canyon') || variant_value.includes('Bonfire') || variant_value.includes('Ocean') || variant_value.includes('Hello World') || variant_value.includes('PITAKA Monogram') || variant_value.includes('Black/Gold');
              if(is_webp || product_handle.includes('three-body') || product_handle.includes('pixel-game') || product_handle.includes('aries-collab')){
                if (product_handle.includes('aries-collab')) {
                  if (product_handle.includes('cases') || product_handle.includes('-for-iphone-17-series')) {
                    color_prefix = `case-${color_prefix.replace('-lumintex-edition','')}`;
                  }else if (product_handle.includes('charm')){
                    color_prefix = `keychain-${color_prefix}`;
                  }
                }else if (product_handle.includes('photosynthesis')) {
                  color_prefix = `photosynthesis-${color_prefix}`;
                }
                color_src = `https://www.ipitaka.com/cdn/shop/t/84/assets/${color_prefix}.webp`;
              }else if(variant_value.includes('NoProblemo') || variant_value.includes('Credit card') || variant_value.includes('Alien')){
                if (product_handle == 'trade-in-phone-cases' || product_handle.includes('power-bank') || product_handle.includes('woven-wallet')) {
                  color_src = `https://www.ipitaka.com/cdn/shop/t/84/assets/case-${color_prefix}.webp`;
                }
              }else if(product_handle.includes('fathers-day-gift-powerbank')){
                if (product_handle.includes('military') && variant_value.includes('Black/Grey')) {
                  color_src = `https://www.ipitaka.com/cdn/shop/t/84/assets/black-grey-twill.svg`;
                }else if(product_handle.includes('ultra-slim') && variant_value.includes('Black/Grey')){
                  color_src = `https://www.ipitaka.com/cdn/shop/t/84/assets/600d-black-grey-twill.svg`;
                }else{
                  color_src = `https://www.ipitaka.com/cdn/shop/t/84/assets/${color_prefix}.svg`;
                }
              }else if(product_handle.includes('folio-2') && variant_value == 'White'){
                color_src = 'https://www.ipitaka.com/cdn/shop/t/84/assets/folio-white.svg';
              }else{
                color_src = `https://www.ipitaka.com/cdn/shop/t/84/assets/${color_prefix}.svg`;
              }
              
              swatch_label = `<label for="swatch_${form_index}-${i}-${handle_value}" data-src="${color_src}"
                class="w-12 sm:w-14 opacity-60 overflow-hidden border border-transparent relative"       
                style="background-image: url(${color_src});">
                <img class="crossed-out" src="${soldout_src}"/>
              </label>`;
            }else{
              if (variant_value.includes('--')) {
                swatch_label = `<label class="border border-black border-opacity-60 text-center px-2 py-1.5 relative"
                  for="swatch_${form_index}-${i}-${handle_value}">
                  <span class="block">${variant_value.split('--')[0]}</span>
                  <span class="block opacity-80 mt-0.5">${variant_value.split('--')[1]}</span>
                </label>`;
              } else {
                swatch_label = `<label class="border border-black border-opacity-60 px-2 py-1.5 relative"
                  for="swatch_${form_index}-${i}-${handle_value}">
                  ${variant_value}
                </label>`;
              }
            }
            const swatch_variant = `<div data-value="${variant_value}"
              class="swatch-element w-full max-w-max ${roundedClass} ${handle_value} available">
              <input id="swatch_${form_index}-${i}-${handle_value}" 
                type="radio" name="option-${i}" value="${variant_value}"
              />${swatch_label}</div>`;
            swatch_variants += swatch_variant;
          }
        }

        var swatchHidden = '';
        if (product_handle.includes('phone-cases') && is_device) {
          swatchHidden = ' hidden';
        }
        var swatch_color_types = '';
        if(is_color && product_handle.includes('-phone-cases')){
          const product_options_color = product.options.filter(item => item.name == 'Color')[0].values;
          // console.log(product_options_color)
          var type_arr = [];
          for (let i = 0; i < product_options_color.length; i++) {
            const option_color = product_options_color[i];
            const color_type =  option_color.includes(' | ') ? option_color.split(' | ')[1].trim() : option_color;
            type_arr.push(color_type);
          }
          const type_list = [...new Set(type_arr)];
          var type_items = '';
          for (let j = 0; j < type_list.length; j++) {
            const type_item = type_list[j];
            type_items += `<button type="button" data-type="${type_item}"
              class="option-type w-1/3 sm:w-max px-3 block border-t border-b border-grey text-grey md:text-black md:border-black py-1 sm:py-1.5">
              <span class="block" text="${type_item.replace(' Case','')}">${type_item.replace(' Case','')}</span>
            </button>`;
            
          }
          swatch_color_types = `<div class="my-8 sm:my-12 md:my-10 xl:my-12">
            <h3 class="heading mb-3">Case Type</h3>
            <div class="space-y-5">
              <div class="option-types flex space-x-3 sm:space-x-4 lg:space-x-5 xl:space-x-6 text-size-12 xs:text-size-14 sm:text-size-16 text-center">
                ${type_items}
              </div>
              <div class="option-specs space-y-3 leading-none">
                <div class="w-2/3 lg:w-5/9 space-y-1">
                  <span class="block">Protection:</span>
                  <div class="block w-full h-1 bg-grey-200 overflow-hidden relative">
                    <span class="block specs-protection absolute inset-y-0 w-3/5 bg-blue"></span>
                  </div>
                </div>
                <div class="w-2/3 lg:w-5/9 space-y-1">
                  <span class="block">Weight:</span>
                  <div class="block w-full h-1 bg-grey-200 overflow-hidden relative">
                    <span class="block specs-weight absolute inset-y-0 w-1/5 bg-blue"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>`
        }
        form_swatches += `<div class="swatch swatch-${downcased_option} clearfix mb-3 sm:mb-5 xl:mb-6${swatchHidden}" 
          data-option-index="${i}">
          ${swatch_color_types}
          <h3 class="heading relative mb-2">
            ${swatch_title}
          </h3>
          <div class="flex flex-wrap -mb-2">${swatch_variants}</div></div>`;
      }
    }

    if(product.available){
      form_button = `<button type="submit" name="add" class="AddToCart py-2 sm:py-2.5">
        <span class="AddToCartText" text="Add to cart">Add to cart</span>
      </button>`;
    }else{
      form_button = `<button type="submit" name="add" class="AddToCart py-2 sm:py-2.5 disabled">
        <span class="AddToCartText" text="Unavailable">Unavailable</span>
      </button>`;
    }

    var gallery_items = '';
    if (product.variants.length > 1) {
      for (const variant of product.variants) {
        // console.log(variant);
        if (variant.featured_image) {
          gallery_items += `<li data-image-id="${ variant.featured_image.id }" title="${variant.title}" 
            class="gallery__item" data-mfp-src="${variant.featured_image.src}"></li>`;
        }
      }
    } else {
      gallery_items == `<li data-image-id="${form_variant.id}" title="${product.title}" 
        class="gallery__item" data-mfp-src="${product.featured_image}"></li>`;
    }

    // product_handle == 'classic-phone-cases' || product_handle == 'starpeak-phone-cases' ||
    var pitatap_info = '', aaron_info = '';
    if (product_handle.includes('-phone-cases')) {
      pitatap_info = `<div class="pitatap-info-container absolute w-4/5 sm:w-3/5 right-0 bottom-0 transform -translate-y-1/6 z-50">
        <div class="w-full p-3 sm:p-4 bg-grey-200 rounded-lg relative">
          <button class="btn-close absolute top-2.5 right-2.5 lg:top-3 lg:right-3" type="button">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="20" height="20" viewBox="0 0 20 20" 
              class="block w-3.5 sm:w-4 lg:w-5 h-auto"><g><g><ellipse cx="10" cy="10" rx="10" ry="10" fill="#8C8A86" fill-opacity="1"/></g><g><rect x="4" y="9" width="12" height="2" rx="0" fill="#F2F0ED" fill-opacity="1"/></g></g></svg>
          </button>
          <div class="flex flex-col items-end text-size-12 sm:text-size-14 lg:text-size-16 space-y-3">
            <h3 class="w-full text-size-14 xs:text-size-16 sm:text-size-20 lg:text-size-24">
              World’s first PitaTap™
            </h3>
            <p class="w-full text-grey font-light">
              Revolutionary camera control, reimagined in aramid fiber. <br>
              With the PitaTap™ seamlessly molded into the case, enjoy smooth, 
              precise control without compromising the sleek aesthetic.
            </p>
            <div class="w-full py-2">
              <img data-src="//3wdre8-x8.myshopify.com/cdn/shop/t/25/assets/sunset-pitatap-info.webp?v=54310399517741774761780287338" alt="About PitaTap™" 
                width="240" height="213" class="block w-full sm:w-4/5 rounded-md lazyload">
            </div>
          </div>
        </div>
      </div>`;
      aaron_info = `<div class="aaron-info-container absolute w-4/5 sm:w-3/5 right-0 bottom-0 transform -translate-y-1/6 z-50">
        <div class="w-full p-3 sm:p-4 bg-grey-200 rounded-lg relative">
          <button class="btn-close absolute top-2.5 right-2.5 lg:top-3 lg:right-3" type="button">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="20" height="20" viewBox="0 0 20 20" 
              class="block w-3.5 sm:w-4 lg:w-5 h-auto"><g><g><ellipse cx="10" cy="10" rx="10" ry="10" fill="#8C8A86" fill-opacity="1"/></g><g><rect x="4" y="9" width="12" height="2" rx="0" fill="#F2F0ED" fill-opacity="1"/></g></g></svg>
          </button>
          <div class="flex flex-col items-end text-size-12 sm:text-size-14 lg:text-size-16 space-y-3">
            <h3 class="w-full text-size-14 xs:text-size-16 sm:text-size-20 lg:text-size-24">
              About Aaron Button
            </h3>
            <p class="w-full text-grey font-light">
              The three Aaron Buttons are customizable to quickly launch your most-used functions. 
              With one-touch activation to any app or action you choose, 
              it turns everyday interactions into moments where creativity 
              and effortless efficiency come together.
            </p>
            <div class="w-full py-2">
              <img data-src="//3wdre8-x8.myshopify.com/cdn/shop/t/25/assets/sunset-aaron-info.webp?v=183837446592355448701780287322" alt="About Aaron Button" 
                width="240" height="213" class="block w-full sm:w-4/5 rounded-md lazyload">
            </div>
          </div>
        </div>
      </div>`;
    }

    const gridFormModal = `<div class="grid-form-modal fixed inset-0 flex items-end md:items-center justify-center bg-black bg-opacity-50 z-10 active" data-product="${product_handle}">
      <div class="w-full sm:w-4/5 md:w-3/5 lg:w-5/9 xl:w-1/2 h-9/10 sm:h-5/6">
        <form action="/cart/add" class="w-full h-full px-4 sm:px-6 lg:px-8 flex flex-col bg-grey-100 relative" enctype="multipart/form-data" method="post">
          <div class="form_btn-close flex-shrink-0 h-6 sm:h-8 flex items-center justify-end cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1"
              width="18.85595703125" height="18.856170654296875" viewBox="0 0 18.85595703125 18.856170654296875"
              class="block h-4/5 h-auto">
              <g
                transform="matrix(0.7071067690849304,0.7071067690849304,-0.7071067690849304,0.7071067690849304,2.761391088439268,-6.666587427185732)">
                <g>
                  <g>
                    <line x1="9.427978515625" y1="6.7727274894714355" x2="22.761310577392578" y2="6.7727274894714355"
                      fill-opacity="0" stroke-opacity="1" stroke="#8A8884" fill="none" stroke-width="1"></line>
                  </g>
                  <g transform="matrix(0,-1,1,0,3.3673739433288574,30.034038066864014)">
                    <line x1="16.700706005096436" y1="12.833332061767578" x2="30.034038066864014" y2="12.833332061767578"
                      fill-opacity="0" stroke-opacity="1" stroke="#8A8884" fill="none" stroke-width="1"></line>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="h-28 xs:h-32 sm:36 md:h-40 lg:h-44 xl:h-48 flex-shrink-0 flex items-stretch py-4 border-t border-b">
            <div class="product-single__photos h-full bg-grey-200 relative">
              <img data-src="${variant_image_180}" data-image-id="${variant_image_id}"
                class="variant__image block w-full h-full object-contain object-center lazyload"
                alt="${product.title}">
            </div>
            <ul class="gallery hidden">
              ${gallery_items}
            </ul>
            <div class="w-3/4 flex flex-col justify-between pl-2.5 leading-none">
              <div class="product_content-title" itemprop="name">
                ${form_title}
              </div>
              <div class="product_content-prices py-2.5 xs:py-3 sm:py-4 flex items-center justify-between">
                <div class="form-single__prices">
                  ${form_prices}
                </div>
                <div class="product-single__quantity hidden">
                  <div class="number-box flex items-center border-t border-b">
                    <input type="button" class="on-number" data-v="-1" value="-" disabled>
                    <input name="quantity" type="text" value="1" data-min="1" data-max="${quantifyMax}">
                    <input type="button" class="on-number" data-v="1" value="+">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <input type="hidden" name="cart_autoClose" value="1">
          <div class="main-form-container h-full min-h-0 flex flex-col justify-between text-size-14 sm:text-size-16 md:text-size-14 xl:text-size-16">
            <div class="variant-select-container h-full py-5 overflow-y-auto">
              <select name="id" id="productSelect_${ form_index }" class="product-single__variants hidden">
                ${form_options}
              </select>
              ${form_swatches}
            </div>
            <div class="product-form__buttons space-y-4 sm:space-y-6 flex-shrink-0 pb-3 sm:pb-4 lg:pb-6">
              <div class="ot-estimated-shipping"></div>
              <div class="addtocartBtn font-light">${form_button}</div>
            </div>
            ${pitatap_info}
            ${aaron_info}
          </div>
        </form>
      </div>
    </div>`;

    $("#PageContainer").after(gridFormModal);

    timber.selectVariant(form_index, product);
    if(selected_variant != ''){
      const value_arr = selected_variant.split(' / ');
      for (let i = 0; i < value_arr.length; i++) {
        const val = value_arr[i];
        $('.grid-form-modal').find( `.swatch :radio[value='${val}']`).click();
      }
      if (product_handle.includes('phone-cases')) {
        const default_option_type = value_arr[1].split(' | ')[1];
        $('.grid-form-modal').find(`.option-types .option-type[data-type="${default_option_type}"]`).click();
      }
    }

    $('.grid-form-modal').find('.gallery__item').magnificPopup({
      type: 'image',
      mainClass: 'mfp-fade',
      closeOnBgClick: true,
      closeBtnInside: false,
      closeOnContentClick: true,
      tClose: 'Close',
      removalDelay: 500,
      callbacks: {
        open: function(){
          $('html').css('overflow-y','hidden');
        },
        close: function(){
          $('html').css('overflow-y','');
        }
      },
      titleSrc: 'title',
      gallery: {
        enabled: true,
        navigateByImgClick: false,
        arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
        tPrev: 'Prev',
        tNext: 'Next'
      }
    });
  });
}
// Initialize Timber's JS on docready
$(timber.init)